import { i18n } from '@/locales';
import { routeName } from './routeName';
const t = i18n.t.bind(i18n);
export default {
    workerManagementGroupSetting: [
        // 라이더 수수료 그룹 설정
        {
            title: t('views.delivery_fee_group_setting.page_title'),
            to: routeName.WORKER_MANAGEMENT_DELIVERY_FEE_GROUP_SETTING,
        },
        // 자동 차감 그룹 설정
        {
            title: t('views.cash_auto_deduct_group_setting.page_title'),
            to: routeName.WORKER_MANAGEMENT_CASH_AUTO_DEDUCT_GROUP_SETTING,
        },
        // 배차취소 패널티 그룹 설정
        {
            title: t('views.allocated_cancel_penalty_group_setting.page_title'),
            to: routeName.WORKER_MANAGEMENT_ALLOCATED_CANCEL_PENALTY_GROUP_SETTING,
        },
    ],
    storeManagementGroupSetting: [
        // 라이더 수수료 그룹 설정
        {
            title: t('views.worker_fee_per_store_group_setting.page_title'),
            to: routeName.STORE_MANAGEMENT_WORKER_FEE_PER_STORE_GROUP_SETTING,
        },
    ],
};
